import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEqual } from 'lodash';
import Timer from './Timer';
import { ERROR_REFRESH_TIMER, ERROR_INFINITE_REFRESH_TIMES } from '../actions/urlTypes';
import { saveErrorDetails } from '../util/trackerUtils';
import errorIcon from '../images/error_image.svg';
import { logOut } from '../actions/loginActions';

class ErrorBoundary extends Component {
  static getDerivedStateFromError() {
    return {
      hasError: true,
    };
  }

  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      logInfo: '',
      showTimer: true,
    };
  }

  componentDidCatch = error => {
    let productNo;
    const urlPath = location.pathname;
    let errorCount = sessionStorage.errorCount || '0';
    const backupRedux = sessionStorage.backupReduxState &&
      JSON.parse(sessionStorage.backupReduxState);
    const isReduxEqual = isEqual(backupRedux, this.props.reduxState);
    if (!isReduxEqual) {
      sessionStorage.setItem('errorCount', '0');
      sessionStorage.removeItem('backupReduxState');
      errorCount = '0';
    }
    const moduleName = urlPath.substr(urlPath.lastIndexOf('/') + 1, urlPath.length);
    const subModule = sessionStorage.getItem('subModule') || null;
    if (Number(errorCount) < (ERROR_INFINITE_REFRESH_TIMES - 1)) {
      setTimeout(() => {
        const count = Number(errorCount) + 1;
        try {
          sessionStorage.setItem('errorCount', JSON.stringify(count));
          sessionStorage.setItem('reduxState', JSON.stringify(this.props.reduxState));
        } catch (error) {
          console.error('Error occured, page will refresh automatically');
          location.reload();
        }
        location.reload();
      }, ERROR_REFRESH_TIMER * 1000);
    } else {
      this.setState({ showTimer: false }, () => {
        sessionStorage.removeItem('errorCount');
        sessionStorage.removeItem('reduxState');
        sessionStorage.removeItem('backupReduxState');
        logOut();
      });
    }

    switch (moduleName) {
      case 'crosstab': {
        productNo = this.props.crosstabStudy && this.props.crosstabStudy.pn;
        break;
      }
      case 'quickreports': {
        productNo = this.props.quickReportsStudy && this.props.quickReportsStudy.pn;
        break;
      }
      case 'datahaul': {
        productNo = this.props.datahaulStudy && this.props.datahaulStudy.pn;
        break;
      }
      case 'stories': {
        productNo = this.props.visahaulStudy && this.props.visahaulStudy.pn;
        break;
      }
      case 'mme': {
        productNo = this.props.mmeStudy && this.props.mmeStudy.pn;
        break;
      }
      case 'geomap': {
        productNo = this.props.geoMapStudy && this.props.geoMapStudy.pn;
        break;
      }
      case 'brandcatalyst': {
        productNo = this.props.insight360study && this.props.insight360study.pn;
        break;
      }
      case 'salescatalyst': {
        productNo = this.props.salesCatalystStudy && this.props.salesCatalystStudy.pn;
        break;
      }
      default: break;
    }
    saveErrorDetails({
      accountId: this.props.activeAccountId,
      app: 'insights-ui',
      moduleName,
      productNo: productNo || 0,
      detail: JSON.stringify(error.stack),
      subModule,
    });
    // extra condition added to test infinite loop
    if (this.state.logInfo === '') {
      this.setState(() => ({ logInfo: error.stack }));
    }
  }

  render() {
    const locationUrl = window.location.hostname;
    let showBoundaryError = false;
    if (!locationUrl.includes('insights.mrisimmons')) {
      showBoundaryError = true;
    }
    if (this.state.hasError) {
      return (
        <div className="error-boundary-container">
          <div className="error-boundary-img-content">
            <img alt="Error" src={errorIcon} />
            <div className="error-boundary-message-1">OOPS...</div>
          </div>
          <div className="error-boundary-message-2"> Sorry, something went wrong on our side. We are getting you right back to work.</div>
          {this.state.showTimer && <Timer seconds={ERROR_REFRESH_TIMER} />}
          {showBoundaryError && <h3>{this.state.logInfo}</h3>}
        </div>
      );
    }
    return this.props.children;
  }
}

ErrorBoundary.propTypes = {
  activeAccountId: PropTypes.number,
  crosstabStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  quickReportsStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  visahaulStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  datahaulStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  insight360study: PropTypes.shape({
    pn: PropTypes.number,
  }),
  salesCatalystStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  mmeStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  geoMapStudy: PropTypes.shape({
    pn: PropTypes.number,
  }),
  reduxState: PropTypes.shape({}),
  children: PropTypes.shape({}),
};

function mapStateToProps(state) {
  return {
    activeAccountId: state.account.activeAccountId,
    crosstabStudy: state.study.crosstabStudy,
    quickReportsStudy: state.study.quickReportsStudy,
    datahaulStudy: state.study.datahaulStudy,
    visahaulStudy: state.study.visahaulStudy,
    mmeStudy: state.study.mmeStudy,
    geoMapStudy: state.study.geoMapStudy,
    insight360study: state.study.insight360study,
    salesCatalystStudy: state.study.salesCatalystStudy,
    reduxState: state,
  };
}

export default connect(mapStateToProps, null)(ErrorBoundary);
